import React, { Fragment, useEffect, useState } from "react";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import Select from "../../Common/FormElements/Select/Select";
import TextArea from "../../Common/FormElements/TextArea/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { productForm, productServiceForm } from "./data";
import { Col, Row } from "react-bootstrap";
import { isDefined } from "../../../Utils";
import { getAccessoryRelatedProducts } from "../../../REDUX/actions/products";
import MultiSelectCheckbox from "../../Common/FormElements/MultiSelectCheckbox";
import { useTranslation } from "react-i18next";
import CalendarInput from "../../Common/FormElements/CalendarInput/CalendarInput";
import moment from "moment";
import SwitchButton from "../../Common/FormElements/SwitchButton/SwitchButton";

const GeneralInfoProduct = ({ handleFormsChange, initialValues }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const optionsTypes = [
    {
      name: t("Products"),
      code: 1,
    },
    {
      name: t("Accessories"),
      code: 2,
    },
    {
      name: t("Marketing Products"),
      code: 3,
    },
    {
      name: t("Spare Part"),
      code: 4,
    },
    {
      name: t("Services"),
      code: 5,
    },
    {
      name: t("Other branded products"),
      code: 6,
    },
  ];
  const { categories } = useSelector((state) => state.categoryReducer);
  const { productSizes } = useSelector((state) => state.productSizeReducer);
  const { deliveryTypes } = useSelector((state) => state.deliveryTypeReducer);
  const { relatedProducts } = useSelector((state) => state.productsReducer);
  const [formData, setFormData] = useState(initialValues ?? {});

  const [fetchedData, setFetchedData] = useState({
    productType: optionsTypes,
    kangourou: [
      { code: 0, name: t("Without kangaroo pocket") },
      { code: 1, name: t("With kangaroo pocket") },
    ],
  });
  const [renderedProductsForms, setRenderedProductsForms] = useState(
    (formData?.productType?.code === 5 || formData?.productType?.code === 6
      ? productServiceForm
      : productForm
    )?.filter((el) => el?.name !== "related_products"),
  );

  const handleChange = (e) => {
    const { value, name } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    handleFormsChange("product", formData);
  }, [formData]);

  useEffect(() => {
    if (!isDefined(formData?.productType?.code)) {
      setRenderedProductsForms(
        (formData?.productType?.code === 5 || formData?.productType?.code === 6
          ? productServiceForm
          : productForm
        )?.filter(
          (el) =>
            ![
              "related_products",
              "accessoryWeight",
              "accessoryDimension",
              "category",
              "gamme",
              "product_size",
              "multipleContainer",
              "delivery_types",
              "kangourou",
            ]?.includes(el?.name),
        ),
      );
    } else if (formData?.productType?.code === 1) {
      setRenderedProductsForms(
        (formData?.productType?.code === 5 || formData?.productType?.code === 6
          ? productServiceForm
          : productForm
        )?.filter(
          (el) =>
            ![
              "related_products",
              "accessoryWeight",
              "accessoryDimension",
              "kangourou",
            ]?.includes(el?.name),
        ),
      );
      setFetchedData((fetchedData) => ({
        ...fetchedData,
        category: categories.map((item) => ({
          name: t(`${item?.name}`, { ns: "common" }),
          code: item?.code,
        })),
      }));
    } else {
      setFetchedData((fetchedData) => ({
        ...fetchedData,
        related_products: relatedProducts,
      }));

      setRenderedProductsForms(
        (formData?.productType?.code === 5 || formData?.productType?.code === 6
          ? productServiceForm
          : productForm
        ).filter(
          (formElement) =>
            ![
              "category",
              "gamme",
              "product_size",
              "multipleContainer",
            ]?.includes(formElement?.name),
        ),
      );
    }
  }, [formData?.productType?.code, relatedProducts]);

  useEffect(() => {
    if (formData?.productType?.code !== 1) {
      dispatch(getAccessoryRelatedProducts());
    }
  }, [formData?.productType?.code, dispatch]);

  useEffect(() => {
    if (isDefined(formData?.category?.code)) {
      setFetchedData((fetchedData) => ({
        ...fetchedData,
        gamme: categories?.find(
          (item) => +formData?.category?.code === +item?.code,
        )?.ranges,
      }));
    }
  }, [categories, formData?.category?.code]);

  useEffect(() => {
    if (isDefined(formData?.category?.code)) {
      handleFormsChange("product", {
        ...formData,
        gamme: !!fetchedData?.gamme?.find(
          (item) => +item?.code === +formData?.gamme?.code,
        )
          ? formData?.gamme
          : {},
      });
    }
  }, [formData.category?.code, fetchedData?.gamme]);

  useEffect(() => {
    setFetchedData((fetchedData) => ({
      ...fetchedData,
      delivery_types: deliveryTypes.map(({ label, value }) => ({
        label: t(`${label}`),
        value,
      })),
      product_size: productSizes.map(({ name, code }) => ({
        name: t(`${name}`),
        code,
      })),
    }));
  }, [deliveryTypes, productSizes]);

  return (
    <>
      <div className="d-flex flex-stretch">
        <Row className="gx-5">
          <Col lg={8}>
            <Row>
              {renderedProductsForms.map((el, index) => {
                if (el.type === "textarea" || el.name.includes("_en"))
                  return null;
                if (el.type === "multiSelectCheckbox")
                  return (
                    <Fragment key={el?.name}>
                      <Col
                        lg={6}
                        key={el.name}
                        className="mb-3 d-flex flex-column gap-2"
                      >
                        <div>
                          <span className="text-softBlack normalf16">
                            {t(`${el.label}`, { ns: "common" })}
                          </span>
                          {/* {el.required && (
                            <span className="text-lameRed normalf16"> *</span>
                          )} */}
                        </div>
                        <MultiSelectCheckbox
                          filter={el?.filter}
                          name={el.name}
                          placeholder={t(`${el.label ?? ""}`, { ns: "common" })}
                          value={formData[el.name]}
                          options={
                            el.name === "delivery_types"
                              ? formData.productType?.code === 1
                                ? fetchedData[el.name]?.filter(
                                    (el) => el.value <= 3 || el.value >= 6,
                                  )
                                : fetchedData[el.name]?.filter(
                                    (el) => el.value >= 4,
                                  )
                              : fetchedData[el.name]
                          }
                          disabled={
                            el?.disabledByOptions &&
                            !fetchedData[el.name]?.length > 0
                          }
                          label={t(`${el.label}`, { ns: "common" })}
                          callback={handleChange}
                        />
                      </Col>
                      {(index === 3 || el?.name === "publicPriceTTC") &&
                        index < renderedProductsForms.length - 2 && (
                          <Col
                            lg={12}
                            className="mb-3 mt-0 d-flex flex-column gap-2"
                          >
                            <hr
                              style={{
                                borderColor: "#abb8b2",
                                marginBottom: 0,
                              }}
                              width={"100%"}
                            />
                          </Col>
                        )}
                    </Fragment>
                  );
                if (el.type === "select") {
                  return (
                    <Fragment key={el?.name}>
                      <Col
                        lg={6}
                        key={el.name}
                        className="mb-3 d-flex flex-column gap-2"
                      >
                        <div>
                          <span className="text-softBlack normalf16">
                            {t(`${el.label}`, { ns: "common" })}
                          </span>
                          {/* {el.required && (
                            <span className="text-lameRed normalf16"> *</span>
                          )} */}
                        </div>
                        <Select
                          multipe
                          name={el.name}
                          placeholder={t(`${el.label ?? ""}`, { ns: "common" })}
                          value={
                            formData[el.name] === "kangourou"
                              ? formData[el.name]
                              : formData[el.name]
                          }
                          options={fetchedData[el.name]}
                          disabled={
                            el?.disabledByOptions &&
                            !fetchedData[el.name]?.length > 0
                          }
                          label={t(`${el.label}`, { ns: "common" })}
                          callback={handleChange}
                        />
                      </Col>
                      {(index === 3 || el?.name === "publicPriceTTC") &&
                        index < renderedProductsForms.length - 2 && (
                          <Col
                            lg={12}
                            className="mb-3 mt-0 d-flex flex-column gap-2"
                          >
                            <hr
                              style={{
                                borderColor: "#abb8b2",
                                marginBottom: 0,
                              }}
                              width={"100%"}
                            />
                          </Col>
                        )}
                    </Fragment>
                  );
                }

                if (el.type === "date") {
                  return (
                    <Fragment key={el?.name}>
                      <Col
                        lg={6}
                        key={el.name}
                        className="mb-3 d-flex flex-column gap-2"
                      >
                        <div>
                          <span className="text-softBlack normalf16">
                            {t(`${el.label}`, { ns: "common" })}
                          </span>
                          {/* {el.required && (
                            <span className="text-lameRed normalf16"> *</span>
                          )} */}
                        </div>
                        <CalendarInput
                          {...el}
                          minDate={false}
                          placeholder={t(`${el.placeholder}`)}
                          className="w100"
                          value={
                            formData[el.name]
                              ? moment(formData[el.name]).toDate()
                              : null
                          }
                          callback={handleChange}
                        />
                      </Col>
                      {(index === 3 || el?.name === "discountEndDate") &&
                        index < renderedProductsForms.length - 2 && (
                          <Col
                            lg={12}
                            className="mb-3 mt-0 d-flex flex-column gap-2"
                          >
                            <hr
                              style={{
                                borderColor: "#abb8b2",
                                marginBottom: 0,
                              }}
                              width={"100%"}
                            />
                          </Col>
                        )}
                    </Fragment>
                  );
                }
                return (
                  <Fragment key={el.name}>
                    <Col lg={6} className="mb-3 d-flex flex-column gap-2">
                      <div>
                        <span className="text-softBlack normalf16">
                          {t(`${el.label}`, { ns: "common" })}
                        </span>
                        {/* {el.required && (
                          <span className="text-lameRed normalf16"> *</span>
                        )} */}
                      </div>
                      <TextInput
                        className={"w100"}
                        type={el.type}
                        name={el.name}
                        value={formData[el.name]}
                        placeholder={t(`${el.placeholder ?? ""}`, {
                          ns: "common",
                        })}
                        surfixText={
                          formData?.productType?.code === 6 && el?.surfixText
                            ? "$"
                            : el?.surfixText && "€"
                        }
                        // euro={
                        //   formData?.productType?.code === 6 ? "dollar" : el.euro
                        // }
                        callback={handleChange}
                      />
                    </Col>
                    {(index === 3 || el?.name === "publicPriceTTC") &&
                      formData?.productType?.code !== 5 &&
                      index < renderedProductsForms.length - 2 && (
                        <Col
                          lg={12}
                          className="mb-3 mt-0 d-flex flex-column gap-2"
                        >
                          <hr
                            style={{ borderColor: "#abb8b2", marginBottom: 0 }}
                            width={"100%"}
                          />
                        </Col>
                      )}
                  </Fragment>
                );
              })}
              <Col lg={12}>
                <hr
                  style={{ borderColor: "#abb8b2", marginBottom: 0 }}
                  width={"100%"}
                />
                <div className="mt-3 d-flex flex-row gap-2 align-items-center">
                  <SwitchButton
                    small
                    isActive={!!formData.adminOnly}
                    onClick={() =>
                      handleChange({
                        target: {
                          name: "adminOnly",
                          value: !formData.adminOnly,
                        },
                      })
                    }
                  />
                  <span className="text-softBlack normalf16">
                    {t("Visible only to administrators")}
                  </span>
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            lg={4}
            className="d-flex flex-column gap-2 border-start border-darkGrey"
          >
            <span className="text-softBlack normalf16">
              {t("Description", { ns: "common" })}
            </span>
            <TextArea
              name="description"
              value={formData.description}
              placeholder={t("description", { ns: "common" })}
              className={"w-100 b-2-softGrey h100"}
              rows={10}
              callback={handleChange}
            />
          </Col>
        </Row>
      </div>
      {/* <div className="w-100 alignC gap-3 px-5 pt-3 mt-auto">
        <Button
          variant={"outline"}
          className="px-5"
          onClick={() => dispatch(closeRightModal())}
        >
          Annuler
        </Button>
        <Button
          className="px-5"
          disabled={disabled}
          loading={loading}
          onClick={loading ? undefined : handleClick}
        >
          Enregistrer
        </Button>
      </div> */}
    </>
  );
};

export default GeneralInfoProduct;
